import getStore from '../store/store';
import { getAccountIdentifier } from '../utils/getAccountIdentifier';
import type { CalendarEndpointType } from '../store/schema/CalendarEndpointType';
import type { AccountLoadState } from '../store/schema/AccountLoadState';

export function getAccountLoadState(
    userId: string,
    calendarEndpointType: CalendarEndpointType
): AccountLoadState {
    const { calendarAccountLoadMap } = getStore();
    const accountId = getAccountIdentifier(calendarEndpointType, userId);
    return calendarAccountLoadMap.get(accountId).loadState;
}
